import { render, staticRenderFns } from "./RedmineProject.vue?vue&type=template&id=589d949e&"
import script from "./RedmineProject.vue?vue&type=script&lang=js&"
export * from "./RedmineProject.vue?vue&type=script&lang=js&"
import style0 from "./RedmineProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports